export default "__VITE_ASSET__B6C0_Yhh__"